
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { Toaster } from "@/components/ui/toaster"
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import * as Sentry from "@sentry/react"

// Import Poppins and Montserrat fonts
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import "@fontsource/montserrat/400.css";
import "@fontsource/montserrat/500.css";
import "@fontsource/montserrat/600.css";
import "@fontsource/montserrat/700.css";

// Initialize Sentry
Sentry.init({
  dsn: "https://your-dsn@sentry.io/project-id", // User will need to configure
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  environment: import.meta.env.MODE,
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

// Create optimized query client with caching
import { createOptimizedQueryClient } from '@/lib/cacheManager';
import { AppErrorBoundary } from '@/lib/errorHandler';
import '@/lib/productionInfrastructure'; // Auto-initialize production infrastructure
import { PWAUpdater } from '@/components/PWAUpdater';
import { EnhancedInstallPrompt } from '@/components/pwa/EnhancedInstallPrompt';

const queryClient = createOptimizedQueryClient();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
        <PWAUpdater />
        <EnhancedInstallPrompt />
        <Toaster />
      </QueryClientProvider>
    </AppErrorBoundary>
  </React.StrictMode>,
)
